import React from "react";
import Select from "components/shared/Select";

class AlphabeticalFilterSelect extends React.Component {
  updateFilter(filter) {
    const $alphabeticalFilters = $(".alphabetical-filters");
    const selector = $alphabeticalFilters.data("selector");
    const $filterEntries = $alphabeticalFilters.find(".filter-entry");

    $(selector).addClass("notransition");

    $filterEntries.removeAttr("data-selected");
    $filterEntries
      .filter(`[data-filter='${filter}']`)
      .attr("data-selected", "true");

    if (filter === "all") {
      $(selector).removeClass("tw-hidden").css("display", "inline-block");
    } else {
      $(selector)
        .addClass("tw-hidden")
        .filter(`[data-sortable^='${filter}']`)
        .removeClass("tw-hidden")
        .css("display", "inline-block");
    }
    $(`${selector}:visible`).each(function (index) {
      $(this).attr("data-column-no", index % 4);
    });

    // flush CSS changes here to prevent toggling of 'notransition' class from happening in the same loop
    // see https://stackoverflow.com/questions/11131875/what-is-the-cleanest-way-to-disable-css-transition-effects-temporarily
    $(selector).each(function (_i, element) {
      // eslint-disable-next-line no-unused-expressions
      element.offsetHeight;
    });
    $(selector).removeClass("notransition");
  }

  onChange(option) {
    this.updateFilter(option.value.toLowerCase());
  }

  render() {
    return (
      <Select
        {...this.props}
        name="alphabetical-filters__select"
        id="alphabetical-filters__select"
        placeholder="Filter by first letter"
        onChange={(value) => this.onChange(value)}
      />
    );
  }
}

export default AlphabeticalFilterSelect;
